module.exports = __webpack_public_path__ + "img/2.92fccf88.jpg";